import type { Nav, Route, StoryItem, StoryPage } from "@/react/story/types";
import { createContext, useContext } from "react";

export type Context = {
    // states
    routes: Route[];
    getNavs(): Nav[];
    // sort
    sort: (items: Nav[]) => void;
    // save
    createItem: (item: Partial<StoryItem>) => Promise<StoryItem>;
    createPage: (page: StoryPage | undefined, idx: number) => Promise<Route>;
    savePage: (page: StoryPage) => void;
    remove: (route: Route) => void;
    // refresh
    fetch: () => Promise<void>;
    // moves
    goto: (route: Route | null) => void;
    createRoute: (item: StoryItem, page: StoryPage) => Route;
    current: Route | null;
    previous: Route | null;
    next: Route | null;
    // getter
    getNewIdx: () => number;
}

export const ItemsContext = createContext<Context>({} as Context);

export const useItems = () => useContext(ItemsContext);
